import { createActionGroup } from '@ngrx/store';

export const ChapterProgressActions = createActionGroup({
  source: 'ChapterProgress',
  events: {},
});
